import {Component, Input, OnInit} from '@angular/core';
import {filter, first, switchMap, takeUntil} from "rxjs/operators";
import {Website} from "../../../website";
import * as fromStore from "../../../../../store";
import {combineLatest, Subject} from "rxjs";
import {Store} from "@ngrx/store";
import {EcommerceService} from "../../ecommerce.service";
import {DbResponse} from "../../../../../shared/interceptors/db-response";
import {NotifierComponent} from "../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../shared/components/notifier/notification-type";

@Component({
    selector: 'db-ecommerce-tax-price-options',
    templateUrl: './tax-price-options.component.html',
    styleUrls: ['./tax-price-options.component.scss'],
    standalone: false
})
export class EcommerceTaxPriceOptionsComponent implements OnInit {
  @Input() website: Website;
  public loading: boolean;
  public connectTaxesEnabled: boolean;
  public pricingIncluded: string;
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private readonly _store: Store<fromStore.DbStoreState>,
    private _ecommerceService: EcommerceService
  ) { }

  ngOnInit() {
    this._getGeneralSettings();
    this._getTaxSettings();
  }

  public connectTaxes(enabled: string): void {
    if (!!this.connectTaxesEnabled) return;
    const taxSettingsForm = {
      includeTax: enabled
    };
    this._ecommerceService.updateTaxSettings(this.website?.id, taxSettingsForm)
      .pipe(filter((response: DbResponse): boolean => !!response),
        first())
      .subscribe((response: DbResponse): void => {
        if (response.success && response?.data) {
          this._store.dispatch(new fromStore.LoadEcommerceGeneralSettings({websiteId: this.website?.id}));
          this._store.dispatch(new fromStore.LoadEcommerceTaxSettings({websiteId: this.website?.id}));
        }
        else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
      });
  }

  private _getGeneralSettings(): void {
    this._store.select(fromStore.getEcommerceGeneralSettingsLoaded(this.website?.id))
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getEcommerceConnectTaxesEnabled(this.website?.id))
        )),
        filter(([connectTaxesEnabled]) => !!connectTaxesEnabled ),
        takeUntil(this._destroyStream$)
      )
      .subscribe(([connectTaxesEnabled]) => {
        this.connectTaxesEnabled = connectTaxesEnabled?.value === 'yes';
      });
  }

  private _getTaxSettings(): void {
    this._store.select(fromStore.getEcommerceTaxSettingsLoaded(this.website?.id))
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getEcommercePricesIncludeTax(this.website?.id))
        )),
        takeUntil(this._destroyStream$)
      )
      .subscribe(([pricingIncluded]) => {
        this.pricingIncluded = pricingIncluded?.value;
      });
  }


}
